Vue.component('spark-update-heatmap-defaults', {
    props: ['team'],
    data: function data() {
        return {
            isLoading: true,
            form: new SparkForm({
                auto: true,
                grid_size: '9x9',
                grid_units: 'miles',
                spacing: '0.25'
            })
        };
    },

    created() {
        axios.get('/heatmap-defaults/' + this.team.id)
            .then(response => {
                // Update the form data if there's any default setting stored in the DB
                this.form.auto = !!response.data.auto;
                if (response.data.grid_size) this.form.grid_size = response.data.grid_size;
                if (response.data.grid_units) this.form.unit = response.data.grid_units;
                if (response.data.spacing) this.form.spacing = response.data.spacing;
                this.isLoading = false;
            })
            .catch(error => {
                console.error('Error fetching heatmap defaults:', error);
            })
            .finally(() => {
                this.isLoading = false;  // Ensure this runs regardless of success or failure
            });
        },

    methods: {
        update() {
            axios.post('/update-heatmap-defaults/' + this.team.id, this.form)
                .then(response => {
                    // Handle success e.g. show a success message
                    this.form.successful = true;
                })
                .catch(error => {
                    // Handle errors e.g. set this.form.errors
                    this.form.errors.set(error.response.data.errors);
                });
        }
    }
});
